// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

enum AccountSettingsTabs {
  Settings = 'settings',
  Account = 'account',
  Authentication = 'authentication',
}

export { AccountSettingsTabs };
